var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"logo-d",attrs:{"src":require("@/assets/images/logo/logo-full.svg"),"alt":"Verificamex"}})
}
var staticRenderFns = []

export { render, staticRenderFns }